export const subpages = "dashboard_admin_subpages";
export const tab = "tab_model_heading";
export const tenant = "nav_tenant";
export const issuer = "nav_issuer";
export const projects = "link_project";
export const products = "meta_title_admin_projects_page";
export const users = "meta_title_admin_user_page";
export const testusers = "dashboard_nav_submenu_testusers";
export const investments = "confirmation_investment";
export const payouts = "payout_nav_title";
export const testingSuite = "dashboard_nav_submenu_testing_suite";
export const orders = "meta_title_admin_order_page";
export const payments = "meta_title_admin_payment_page";
export const broker = "meta_title_broker_page";
export const performance = "meta_title_performance_page";
export const blockchain = "meta_title_admin_blockchain_page";
export const miscellaneous = "dashboard_nav_submenu_miscellaneous";
export const platformSettings = "meta_title_admin_platform_settings_page";
export const dashboard = "meta_title_dashboard_page";
export const tenants = "dashboard_nav_submenu_tenants";
export const secondaryMarket = "dashboard_nav_submenu_secondary_market";
export const rights = "dashboard_nav_submenu_rights";
export const issuers = "dashboard_nav_submenu_issuers";
export const subTenants = "dashboard_nav_submenu_sub_tenants";
export const content = "dashboard_nav_submenu_content";
export const setting = "dashboard_nav_submenu_setting";
export const productCatalog = "dashboard_nav_submenu_product_catalog";
export const personalData = "meta_title_personal_data_page";
export const provision = "dashboard_nav_submenu_provision";
export const information = "information";
export const marketingMaterials = "dashboard_nav_submenu_marketing_materials";
export const documents = "meta_title_admin_documents_page";
export const notification = "meta_title_news_letter_tags_page";
export const overview = "overview";
export const update = "update";
export const account = "account_heading";
export const ewallet = "e-wallet";
export const updateText = "update_text";
export const managingDirector = "managing_director";
export const investors = "meta_title_investors_page";
export const partners = "meta_title_partners_page";
export const investmentProducts = "products";
export const transactions = "transactions";
export const accountSupport = "account_support";
